import Link from 'next/link';
import styles from './FirstTutorsBanner.module.css';

const FirstTutorsBanner = () => {
  return (
    <section className={styles.banner}>
      <div className={styles.inner}>
        <p>
          Coming from First Tutors?
          <Link href="/tutor-migration" passHref>
            <a className={styles.link}>
              Find out what happened and how to migrate your reviews
            </a>
          </Link>
        </p>
      </div>
    </section>
  );
};

export default FirstTutorsBanner;
